import { missingKeyState } from "./missingKeyState";
export function createMissingKeyHandlerOptions() {
    const missingKeyHandler = (_localeCodes, ns, i18nKey, fallbackValue, _updateMissing, _options) => {
        missingKeyState.set(`${ns}:${i18nKey}`, {
            context: ns,
            namespace: ns,
            key: i18nKey,
            defaultText: fallbackValue,
            state: "missing",
        });
    };
    return {
        saveMissing: true,
        saveMissingPlurals: false,
        saveMissingTo: "fallback",
        missingKeyHandler, // if omitted, the default handler will be used
    };
}
//# sourceMappingURL=createMissingKeyHandlerOptions.js.map